// import { Expresion } from "./Expression";
import { makeAutoObservable } from "mobx";
import { FilterItem } from "./FilterItem";
import { LogicOperator } from "./Operator";
import { _ } from "ynf-core-middleware";

export class Logic {
  // 存储一个属性结构，里面可以扩展为Logic
  // eslint-disable-next-line no-use-before-define
  expressionList: Array<FilterItem>;
  // 一组表达式的操作符
  logicOperator: LogicOperator;
  // 一组表达式的名称
  name: string;
  constructor (operator: LogicOperator = LogicOperator.AND, name?: string) {
    this.name = name || "default";
    // eslint-disable-next-line no-array-constructor
    this.expressionList = new Array<FilterItem>();
    this.logicOperator = operator;
    // makeAutoObservable(this, {}, { autoBind: true });
    makeAutoObservable(this, { updateFilter: false }, { autoBind: true });
  }

  isEmpty (value: any) {
    return value == null || value === ''
  }

  /**
   * 校验
   */
  validate () {
    const result: any = [];
    this.expressionList.forEach((item: FilterItem) => {
      if (item.activated && item.meta?.required) {
        const value = item.getQueryValue()
        const v1 = value.v1
        const v2 = value.v2
        if (this.isEmpty(v1) && this.isEmpty(v2)) {
          result.push({
            caption: item.meta.caption,
            name: item.name,
            message: lang.localeUuid('UID:P_CORE-YNF-FE_18953B5805B80006', { caption: item.meta.caption }, '【<%=caption%>】是必填条件')// 【<%=caption%>】是必填条件
          });
        }
      }
    });
    return result;
  }

  /**
   * 获取条件
   * @returns 返回对象{op,items}
   */
  getCondition () {
    return {
      op: this.logicOperator,
      items: this.expressionList
    };
  }

  /**
   * 清空查询FilterItem的值
   */
  clearValue () {
    this.expressionList.forEach((filterItem: FilterItem) => {
      const value = filterItem.meta.defaultValue
        ? filterItem.meta.defaultValue
        : null;
      filterItem.setValue(value);
    });
  }

  // 更新expressionList 引用
  doUpdate () {
    this.expressionList = this.expressionList.filter(() => true);
  }

  /**
   * 设置本Logic下面的查询Items，依据name Update
   * @param list filterItem list
   */
  setExpressionList (list: FilterItem[]) {
    list.forEach((item) => {
      this.updateFilter(item);
    });
    // this.doUpdate()
    // this.expressionList = this.expressionList.filter(() => true);
    // this.expressionList = list;
  }

  /**
   * 添加查询条件
   * @param item item
   */
  addFilter (item: FilterItem) {
    this.updateFilter(item);
    // this.doUpdate()
    // this.expressionList = _.cloneDeep(this.expressionList)
    // this.expressionList.push(item);
  }

  /**
   * 删除查询条件
   * @param item item 或者 name
   */
  removeFilter (item: FilterItem | string) {
    const name = typeof item === "string" ? item : item.getName();
    this.expressionList = this.expressionList.filter(
      (f) => f.getName() !== name
    );
  }

  /**
   * 根据name 更新条件
   * @param item  FilterItem
   */
  updateFilter (item: FilterItem) {
    let flag = false;
    this.expressionList.forEach((f, i) => {
      if (f.getName() === item.getName()) {
        this.expressionList[i] = item;
        flag = true;
      }
    });
    if (!flag) {
      this.expressionList.push(item);
    }
    // this.doUpdate()
  }

  /**
   * 获取值
   * isActivated true 是激活的。false 全部的
   * @param intercept 拦截方法
   * @returns value
   */
  getQueryValue (isActivated: boolean = false, intercept?: Function) {
    // 查询里面的filterItem,构建数据结构
    const result = this.getFilterItem(isActivated, intercept);
    // 循环list 如果里面有logic的话，在调用拿到数据，push到items里面 ,暂时没支持递归
    this.expressionList.forEach((item) => {
      if (item instanceof Logic) {
        // 如果是Logic 的话，递归调用getQueryValue,挂载到item上。
        const r = this.getQueryValue.call(item, isActivated, intercept);
        if (r?.items?.length) {
          result.items.push(r);
        }
      }
    });
    return result;
  }

  /**
   * 获取name
   * @returns string name
   */
  getName () {
    return this.name;
  }

  // getValue(intercept?: Function) {
  //   let items = this.expressionList.map((item: FilterItem) => {
  //     if (item instanceof Logic) {
  //       return item.getValue(intercept);
  //     } else {
  //       return intercept ? intercept(item.getItemValue()) : item.getItemValue();
  //     }
  //   });
  //   items = items.filter((item) =>{
  //     if(item.length){
  //       item = item.filter(v=>v.v1||v.v2)
  //     }else{
  //       return item?.v1 || item?.v2
  //     }
  //   });
  //   return { op: this.logicOperator.operator || this.logicOperator, items };
  // }

  /**
   * 获取查询的FilterItem
   * isActivated 是否是激活的，false 是全部的，true 是激活的
   * @param intercept 拦截方法
   * @returns 返回 对象
   */
  getFilterItem (isActivated: boolean = false, intercept?: Function) {
    const filterItemList: FilterItem[] = this.expressionList.filter((item) => {
      // 筛选 filterItem
      if (isActivated) {
        return item instanceof FilterItem && item.activated;
      } else {
        return item instanceof FilterItem;
      }
    });
    let items = filterItemList.map((item: FilterItem) =>
      intercept ? intercept(item.getQueryValue()) : item.getQueryValue()
    );
    items = items.filter((item) => !this.isEmpty(item?.v1) || !this.isEmpty(item?.v2) || item.items?.length); // 这里不能简单判断v1 v2, 数值是0的就出问题了
    return { op: this.logicOperator.operator || this.logicOperator, items };
  }

  /**
   * 根据name 获取 查询项
   * @param name
   * @returns item
   */
  getFilterItemByName (name: string): Logic | FilterItem | null {
    const items = this.expressionList.filter((item) => item.getName() === name);
    if (items.length) {
      return items[0];
    }
    return null;
  }
}
